import { AppNS, Dcra } from 'app';
import { prepareResponseData } from 'app/api/helpers/prepareResponseData';
import { updateOneCacheItem } from 'app/core/cache/helpers';
import { setCurrentInspectionSwoState } from 'app/store/dcra-inspections/inspections';
import { WebsocketMessage } from 'app/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useQueryClient } from '@tanstack/react-query';

export interface SetInspectionSwoProps {
  message: WebsocketMessage;
}

/**
 * For Job Swo Check
 * @param props
 * @returns
 */
export default function SetInspectionSwo(props: SetInspectionSwoProps) {
  const { message } = props;

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!message.model || message?.model?.error) {
    } else {
      const data = prepareResponseData(message.model) as Dcra.Inspection;

      dispatch(setCurrentInspectionSwoState(data));

      updateOneCacheItem<AppNS.Params>(queryClient, ['inspection/check-swo', message.model.id], {
        id: message.model.id,
        isChecked: message.uuid,
        hasSwo: message.model.state === 'cancelled_by_swo',
        isLoading: false,
      });
    }
  }, [message.uuid]);

  return null;
}
